import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCards = ({ statistics, totalCount }) => {
  const stats = [
    {
      title: 'Total Entries',
      value: totalCount?.toLocaleString() || '0',
      icon: 'FileText',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      title: 'Created',
      value: statistics?.byAction?.created?.toLocaleString() || '0',
      icon: 'PlusCircle',
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    {
      title: 'Updated',
      value: statistics?.byAction?.updated?.toLocaleString() || '0',
      icon: 'Edit',
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50'
    },
    {
      title: 'Deleted',
      value: statistics?.byAction?.deleted?.toLocaleString() || '0',
      icon: 'Trash2',
      color: 'text-red-600',
      bgColor: 'bg-red-50'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg elevation-sm p-4 md:p-6 transition-smooth hover:elevation-md"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`${stat?.bgColor} ${stat?.color} p-3 rounded-lg`}>
              <Icon name={stat?.icon} size={24} />
            </div>
          </div>
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-1">
            {stat?.value}
          </h3>
          <p className="font-body text-sm text-muted-foreground">{stat?.title}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;